var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4345 17.8317L14.1121 2.01048C13.7448 1.3872 13.0749 1 12.3636 1C11.6524 1 10.9824 1.3872 10.6151 2.01053L1.29277 17.8317C0.913194 18.4759 0.901964 19.283 1.26343 19.9381C1.62498 20.5931 2.30617 21 3.04126 21H21.686C22.4211 21 23.1023 20.5931 23.4639 19.938C23.8253 19.2829 23.8141 18.4758 23.4345 17.8317ZM22.1754 19.1934C22.0759 19.3737 21.8883 19.4858 21.686 19.4858H3.04126C2.83889 19.4858 2.65134 19.3738 2.55187 19.1935C2.45235 19.0131 2.45545 18.7909 2.5599 18.6136L11.8823 2.79243C11.9834 2.62086 12.1679 2.51425 12.3637 2.51425C12.5594 2.51425 12.7439 2.62086 12.845 2.79243L22.1673 18.6136C22.2718 18.791 22.2749 19.0132 22.1754 19.1934Z",
    fill: "#2C3E50",
    stroke: "#2C3E50",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3615 7.23828C11.7987 7.23828 11.3594 7.54735 11.3594 8.09527C11.3594 9.76701 11.5515 12.1693 11.5515 13.841C11.5516 14.2765 11.9223 14.4591 12.3616 14.4591C12.691 14.4591 13.1578 14.2765 13.1578 13.841C13.1578 12.1693 13.3499 9.76705 13.3499 8.09527C13.3499 7.5474 12.8969 7.23828 12.3615 7.23828Z",
    fill: "#2C3E50",
    stroke: "#2C3E50",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.393 15.4297C11.789 15.4297 11.3359 15.9214 11.3359 16.5114C11.3359 17.0874 11.789 17.5932 12.393 17.5932C12.9559 17.5932 13.4364 17.0874 13.4364 16.5114C13.4364 15.9214 12.9558 15.4297 12.393 15.4297Z",
    fill: "#2C3E50",
    stroke: "#2C3E50",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlue);
export default __webpack_public_path__ + "static/media/warning-blue.1e05ebf7eb47fb59f1d11cf19fa2f2df.svg";
export { ForwardRef as ReactComponent };